// src/pages/admin/admin-products/AdminProductsPage/components/ProductActions.js
// This component handles product actions like edit, delete, and manage discounts
import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

const ProductActions = ({
    onEdit,
    onDelete,
    onAddDiscount,
    onDirectRemoveDiscount, // New direct removal function
    hasDiscount,
    hasVariants = false,
    productDiscounts = [] // Array of all discounts for this product
}) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    // Count different types of discounts
    const productLevelDiscounts = productDiscounts.filter(d => !d.variantId);
    const variantLevelDiscounts = productDiscounts.filter(d => d.variantId);

    const hasProductDiscount = productLevelDiscounts.length > 0;
    const hasVariantDiscounts = variantLevelDiscounts.length > 0;
    const totalDiscounts = productDiscounts.length;

    const getDiscountButtonText = () => {
        if (!hasDiscount) return t('addDiscount');

        return t('removeDiscount');
    };

    const getDiscountButtonClass = () => {
        let baseClass = "product-action-btn";

        if (!hasDiscount) {
            return `${baseClass} add-discount`;
        }

        return `${baseClass} remove-discount`;
    };

    const handleDiscountRemoval = async () => {
        if (!hasDiscount) {
            // No discounts exist, show add discount modal
            onAddDiscount();
        } else {
            // Confirm before removing all discounts
            if (window.confirm(t('removeDiscountConfirmation', { count: totalDiscounts }))) {
                try {
                    // Remove each discount by calling removeFromSales directly
                    for (const discount of productDiscounts) {
                        await onDirectRemoveDiscount(discount.id);
                    }
                } catch (error) {
                    console.error("Error removing discounts:", error);
                }
            }
        }
    }; return (
        <div className="action-buttons">
            <button
                className="product-action-btn edit"
                onClick={onEdit}
                title={t('editProduct')}
            >
                {t('edit')}
            </button>

            <button
                className={getDiscountButtonClass()}
                onClick={handleDiscountRemoval}
                title={
                    !hasDiscount
                        ? t('addDiscount')
                        : t('removeAllDiscounts')
                }
            >
                {getDiscountButtonText()}
            </button>

            <button
                className="product-action-btn delete"
                onClick={onDelete}
                title={t('deleteProduct')}
            >
                {t('delete')}
            </button>
        </div>
    );
};

export default ProductActions;